













































import {Component, Prop, Vue} from "nuxt-property-decorator";

@Component({})
export default class ProductPrice extends Vue {
  @Prop({type: Number}) private readonly price!: number;
  @Prop({type: Number}) private readonly oldPrice!: number;
  @Prop({type: Number}) private readonly newPrice!: number;
  @Prop({type: String}) private readonly currency!: string;
  @Prop({type: Array}) private readonly promotions?: any;
  @Prop({type: Object, default: null}) private readonly acuvuePromotions?: any;
  @Prop({type: Boolean}) private readonly isHover? : boolean;

  get productPrice(): string {
    const productPromoPrice: any = this.productPromoPrice;
    if (productPromoPrice.priceProduct) {
      return this.formatPrice(productPromoPrice?.priceProduct);
    }

    return this.formatPrice(this.newPrice || this.price);
  }
  get productOldPrice(): string {
    const productPromoPrice: any = this.productPromoPrice;
    if (productPromoPrice.priceProduct) {
      return this.formatPrice(this.newPrice || this.price);
    }

    return this.oldPrice > this.price ? this.formatPrice(this.oldPrice) : "";
  }

  get productPromoPrice(): object {
    const productPrice = this.newPrice || this.price;

    let promotions = (this.promotions || []).filter((promotion: any) => promotion?.visualProfitType);
    if (promotions.length <= 0) {
      return {}
    }

    let promotionMin = {};
    let minProductPrice = productPrice;
    this.promotions.map((promotion: any) => {
      const visualProfitType: any = promotion.visualProfitType;
      const visualProfitValue: any = promotion.visualProfitValue;

      let newProductPrice: any = productPrice;
      if (visualProfitType === "percent") {
        newProductPrice = Math.round(newProductPrice - ((newProductPrice / 100) * Number.parseFloat(visualProfitValue)));
      }
      if (visualProfitType === "fixed") {
        newProductPrice = newProductPrice - Number.parseFloat(visualProfitValue);
      }

      if (newProductPrice > 0 && newProductPrice < minProductPrice) {
        promotionMin = {
          ...promotion,
          priceProduct: newProductPrice
        }
        minProductPrice = newProductPrice;
      }
    })

    return  promotionMin
  }

  get productPriceFromAcuvuePromo() : string {
    if (!this.acuvuePromotions || this.acuvuePromotions === null) {
      return ''
    }
    return this.acuvuePromotions?.characteristics?.[0]?.values?.[0]?.value || '';
  }

  get productPromotionDescriptionFromAcuvue() : string {
    if (!this.acuvuePromotions || this.acuvuePromotions === null) {
      return ''
    }
    return this.acuvuePromotions?.characteristics?.[1]?.values?.[0]?.value || '';
  }

  formatPrice(price: number): string {
    return new Intl.NumberFormat("ru-RU").format(price);
  }
}
